// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"113":"3e7ce5a8","142":"6485e12c","198":"38b0b6c9","221":"473afc26","403":"ea762c17","438":"b35d8e53","648":"8d546361","703":"3a2b9483"}[chunkId] + ".chunk.js";
};